<template>
  <div>user</div>

</template>

<script>
export default {
  name: "User"
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/User.vue